/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type { TaskForAsyncTaskFunction } from "ember-concurrency";

import styles from "./index.module.css";

interface Args {
  mimeType: string;
  alternativeText: string;

  // Either you provide the documentContent, or the retrieveDocumentContent task
  documentContent?: string | undefined;
  isRunning?: boolean;

  retrieveDocumentContent?: TaskForAsyncTaskFunction<
    void,
    (
      modifyDocumentContent: (documentContent: string | undefined) => void
    ) => Promise<void>
  >;

  fileName?: string;
  shouldDisplayDownloadLink?: boolean;
  shouldDisplayTextWithDownloadIcon?: boolean;
  downloadText?: string;
}

export default class FileDisplayer extends Component<Args> {
  styles = styles;

  @service declare store: Store;

  get mimeType() {
    return this.args.mimeType;
  }

  /**
   * Content which will be displayed in the iFrame
   */
  @tracked
  declare documentContent: string | undefined;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (this.args.documentContent) {
      this.documentContent = this.args.documentContent;
    } else {
      const modifyDocumentContent = (documentContent: string | undefined) => {
        this.documentContent = documentContent;
      };
      this.args.retrieveDocumentContent?.perform(modifyDocumentContent);
    }
  }

  get linkSource() {
    return `data:${this.mimeType};base64,${this.documentContent}`;
  }

  get isRunning() {
    return this.args.isRunning || this.args.retrieveDocumentContent?.isRunning;
  }
}
